import type { EstimatedDuration } from '@/types/itinerary';

export const formatDuration = ({ minMinutes, maxMinutes }: EstimatedDuration): string => {
  if (maxMinutes <= 60) return `${minMinutes}–${maxMinutes} min`;
  const fmt = (m: number) => {
    const h = m / 60;
    return Number.isInteger(h) ? `${h}` : h.toFixed(1);
  };
  return `${fmt(minMinutes)}–${fmt(maxMinutes)} hrs`;
};
